(function() {
  const init = function() {
    if (!window.customElements.get("slide-show-item")) {
      // js/custom-element/section/slideshow/slideshow-item.js
      var SlideshowItem = class extends HTMLElement {
        async connectedCallback() {
          this._pendingAnimations = [];
          this.addEventListener("split-lines:re-split", (event) => {
            Array.from(event.target.children).forEach((line) => line.style.visibility = this.selected ? "visible" : "hidden");
          });
          if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            this.setAttribute("reveal-visibility", "");
            Array.from(this.querySelectorAll("[reveal], [reveal-visibility]")).forEach((item) => {
              item.removeAttribute("reveal");
              item.removeAttribute("reveal-visibility");
            });
          }
        }
        get index() {
          return [...this.parentNode.children].indexOf(this);
        }
        get selected() {
          return !this.hasAttribute("hidden");
        }
        async transitionToLeave(transitionType, shouldAnimate = true) {
          if (transitionType !== "reveal") {
            this.setAttribute("hidden", "");
          }
          this._pendingAnimations.forEach((animation2) => animation2.cancel());
          this._pendingAnimations = [];
          let animation = null, textElements = await window.resolveAsyncIterator(this.querySelectorAll("split-lines, .button-group, .button-wrapper")), imageElements = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
          switch (transitionType) {
            case "sweep":
              animation = new window.CustomAnimation(new window.SequenceEffect([
                new window.CustomKeyframeEffect(this, { visibility: ["visible", "hidden"] }, { duration: 500 }),
                new window.ParallelEffect(textElements.map((item) => {
                  if (item.tagName.toLowerCase() === 'p') {
                    item = item.parentElement;
                  }
                  return new window.CustomKeyframeEffect(item, { opacity: [1, 0], visibility: ["visible", "hidden"] });
                }))
              ]));
              break;
            case "fade":
              animation = new window.CustomAnimation(new window.CustomKeyframeEffect(this, { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 250, easing: "ease-in-out" }));
              break;
            case "reveal":
              animation = new window.CustomAnimation(new window.SequenceEffect([
                new window.ParallelEffect(textElements.reverse().map((item) => {
                  if (item.tagName.toLowerCase() === 'p') {
                    item = item.parentElement;
                  }
                  return new window.CustomKeyframeEffect(item, { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 250, easing: "ease-in-out" });
                })),
                new window.ParallelEffect(imageElements.map((item) => {
                  if (!item.classList.contains("slideshow__image-wrapper--secondary")) {
                    return new window.CustomKeyframeEffect(item, { visibility: ["visible", "hidden"], clipPath: ["inset(0 0 0 0)", "inset(0 0 100% 0)"] }, { duration: 450, easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)" });
                  } else {
                    return new window.CustomKeyframeEffect(item, { visibility: ["visible", "hidden"], clipPath: ["inset(0 0 0 0)", "inset(100% 0 0 0)"] }, { duration: 450, easing: "cubic-bezier(0.99, 0.01, 0.50, 0.94)" });
                  }
                }))
              ]));
              break;
          }
          await this._executeAnimation(animation, shouldAnimate);
          if (transitionType === "reveal") {
            this.setAttribute("hidden", "");
          }
        }
        async transitionToEnter(transitionType, shouldAnimate = true, reverseDirection = false) {
          this.removeAttribute("hidden");
          await this._untilReady();
          let animation = null, textElements = await window.resolveAsyncIterator(this.querySelectorAll("split-lines, .button-group, .button-wrapper")), imageElements = Array.from(this.querySelectorAll(".slideshow__image-wrapper"));
          switch (transitionType) {
            case "sweep":
              animation = new window.CustomAnimation(new window.SequenceEffect([
                new window.CustomKeyframeEffect(this, { visibility: ["hidden", "visible"], clipPath: reverseDirection ? ["inset(0 100% 0 0)", "inset(0 0 0 0)"] : ["inset(0 0 0 100%)", "inset(0 0 0 0)"] }, { duration: 500, easing: "cubic-bezier(1, 0, 0, 1)" }),
                new window.ParallelEffect(textElements.map((item, index) => {
                  if (item.tagName.toLowerCase() === 'p') {
                    item = item.parentElement;
                  }
                  return new window.CustomKeyframeEffect(item, { opacity: [0, 1], visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"], transform: ["translateY(100%)", "translateY(0)"] }, { duration: 450, delay: 100 * index, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" });
                }))
              ]));
              break;
            case "fade":
              animation = new window.CustomAnimation(new window.CustomKeyframeEffect(this, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 250, easing: "ease-in-out" }));
              break;
            case "reveal":
              animation = new window.CustomAnimation(new window.SequenceEffect([
                new window.ParallelEffect(imageElements.map((item) => {
                  if (item.tagName.toLowerCase() === 'p') {
                    item = item.parentElement;
                  }
                  if (!item.classList.contains("slideshow__image-wrapper--secondary")) {
                    return new window.CustomKeyframeEffect(item, { visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"] }, { duration: 450, delay: 100, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" });
                  } else {
                    return new window.CustomKeyframeEffect(item, { visibility: ["hidden", "visible"], clipPath: ["inset(100% 0 0 0)", "inset(0 0 0 0)"] }, { duration: 450, delay: 100, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" });
                  }
                })),
                new window.ParallelEffect(textElements.map((item, index) => {
                  if (item.tagName.toLowerCase() === 'p') {
                    item = item.parentElement;
                  }
                  return new window.CustomKeyframeEffect(item, { opacity: [0, 1], visibility: ["hidden", "visible"], clipPath: ["inset(0 0 100% 0)", "inset(0 0 0 0)"], transform: ["translateY(100%)", "translateY(0)"] }, { duration: 450, delay: 100 * index, easing: "cubic-bezier(0.5, 0.06, 0.01, 0.99)" });
                }))
              ]));
              break;
          }
          return this._executeAnimation(animation, shouldAnimate);
        }
        async _executeAnimation(animation, shouldAnimate) {
          this._pendingAnimations.push(animation);
          shouldAnimate ? animation.play() : animation.finish();
          return animation.finished;
        }
        async _untilReady() {
          return Promise.all(this._getVisibleImages().map((image) => window.imageLoaded(image)));
        }
        _preloadImages() {
          this._getVisibleImages().forEach((image) => {
            image.setAttribute("loading", "eager");
          });
        }
        _getVisibleImages() {
          return Array.from(this.querySelectorAll("img")).filter((image) => {
            return getComputedStyle(image.parentElement).display !== "none";
          });
        }
      };
      window.customElements.define("slide-show-item", SlideshowItem);
    }
    if (!window.customElements.get("slide-show")) {
      // js/custom-element/section/slideshow/slideshow.js
      var Slideshow = class extends CustomHTMLElement {
        connectedCallback() {
          this.items = Array.from(this.querySelectorAll("slide-show-item"));
          this.pageDots = this.querySelector("page-dots");
          this.isTransitioning = false;
          if (this.items.length > 1) {
            if (Shopify.designMode) {
              this.addEventListener("shopify:block:deselect", this.startPlayer.bind(this));
              this.addEventListener("shopify:block:select", (event) => {
                this.pausePlayer();
                this.intersectionObserver.disconnect();
                if (!(!event.detail.load && event.target.selected)) {
                  this.select(event.target.index, !event.detail.load);
                }
              });
            }
            this.addEventListener("swiperight", this.previous.bind(this));
            this.addEventListener("swipeleft", this.next.bind(this));
            this.addEventListener("page-dots:changed", (event) => this.select(event.detail.index));
            this._blockVerticalScroll();
          }
          this._setupVisibility();
        }
        get selectedIndex() {
          return this.items.findIndex((item) => item.selected);
        }
        get transitionType() {
          return window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "fade" : this.getAttribute("transition-type");
        }
        async _setupVisibility() {
          await this.untilVisible();
          await this.items[this.selectedIndex].transitionToEnter(this.transitionType).catch((error) => {
          });
          this.startPlayer();
        }
        previous() {
          this.select((this.selectedIndex - 1 + this.items.length) % this.items.length, true, true);
        }
        next() {
          this.select((this.selectedIndex + 1 + this.items.length) % this.items.length, true, false);
        }
        async select(index, shouldTransition = true, reverseDirection = false) {
          if (this.transitionType === "reveal" && this.isTransitioning) {
            return;
          }
          this.isTransitioning = true;
          const previousItem = this.items[this.selectedIndex], newItem = this.items[index];
          this.items[(newItem.index + 1) % this.items.length]._preloadImages();
          if (previousItem && previousItem !== newItem) {
            if (this.transitionType !== "reveal") {
              previousItem.transitionToLeave(this.transitionType, shouldTransition);
            } else {
              await previousItem.transitionToLeave(this.transitionType, shouldTransition);
            }
          }
          if (this.pageDots) {
            this.pageDots.selectedIndex = newItem.index;
          }
          await newItem.transitionToEnter(this.transitionType, shouldTransition, reverseDirection).catch((error) => {
          });
          this.isTransitioning = false;
        }
        pausePlayer() {
          this.style.setProperty("--section-animation-play-state", "paused");
        }
        startPlayer() {
          if (this.hasAttribute("auto-play")) {
            this.style.setProperty("--section-animation-play-state", "running");
          }
        }
        _blockVerticalScroll(threshold = 18) {
          this.addEventListener("touchstart", (event) => {
            this.firstTouchClientX = event.touches[0].clientX;
          });
          this.addEventListener("touchmove", (event) => {
            const touchClientX = event.touches[0].clientX - this.firstTouchClientX;
            if (Math.abs(touchClientX) > threshold) {
              event.preventDefault();
            }
          }, { passive: false });
        }
      };
      Object.assign(Slideshow.prototype);
      window.customElements.define("slide-show", Slideshow);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();